import { render, staticRenderFns } from "./SharepointCallBack.vue?vue&type=template&id=5fb53dc2&"
import script from "./SharepointCallBack.vue?vue&type=script&lang=js&"
export * from "./SharepointCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports